module.exports = __webpack_public_path__ + "static/3-f892d827efa33f1b51ed717248375b25.jpg";